// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrap[data-v-44a57920]{position:relative;height:100%;padding-bottom:95px}.wrap>div[data-v-44a57920]{width:100%;min-height:100%;display:flex;align-items:center}footer[data-v-44a57920]{padding:40px 0;text-align:center;position:relative;width:100%;bottom:0}footer .copy[data-v-44a57920]{font-size:13px;color:#999}", ""]);
// Exports
module.exports = exports;
